<template>
    <div class="pd20x flex1">
        <Loading v-if="loading"></Loading>
        <addOpencourse :visible="visible" @close="visible = false" :data="currentItem" @update="getData"></addOpencourse>
        <div class="h100pct ofA">
            <div class="filter pd20x mb10x">
                <div>科目数量 : {{total}}</div>
                <div>
                    <a-button type="primary" @click="addItem">添加</a-button>
                </div>
            </div>
            <a-table
                    :columns="columns"
                    :data-source="result"
                    :pagination="pagination"
                    :rowKey="'id'"
                    @change="changePage"
            >
                <template slot="name" slot-scope="text">
                    {{text}}
                </template>
                <template slot="showList" slot-scope="text, record,index">
                    <a-switch :defaultChecked="record.show" @change="setShow(index,record.id)"/>
                </template>
                <template slot="homeShow" slot-scope="text, record,index">
                    <a-switch :defaultChecked="record.is_home" @change="setHomeShow(index,record.id)"/>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a-space>
                        <a-button type="primary" style="margin-right:10px" @click="()=>{currentItem = record ; visible = true}">修改科目</a-button>
                        <a-badge :offset="[-55,-2]">
                          <span slot="count" style="background-color: #2196F3; color: #fff">{{ record.bottom.ztNum }}/{{ record.bottom.qtNum }}/{{ record.bottom.vpNum }}</span>
                          <a-button type="primary" ghost style="margin-right:10px" @click="lookPapers(record)">原始素材</a-button>
                        </a-badge>
                        <a-badge :offset="[-55,-2]">
                          <span slot="count" style="background-color: #2196F3; color: #fff">{{ record.bottom.paperNum }}</span>
                          <a-button type="primary" ghost style="margin-right:10px" @click="questionBank(record)">师探题库</a-button>
                        </a-badge>
                        <a-badge :offset="[-55,-2]">
                          <span slot="count" style="background-color: #2196F3; color: #fff">{{ record.bottom.vipNum }}</span>
                          <a-button type="primary" ghost style="margin-right:10px" @click="vipQuestionBank(record)">VIP题库</a-button>
                        </a-badge>
                        <a-badge :offset="[-55,-2]">
                          <span slot="count" style="background-color: #2196F3; color: #fff;width: 70px;text-align: center;">{{ record.bottom.lastDate }}</span>
                          <a-button type="primary" ghost style="margin-right:10px" @click="$router.push({path:'/analysis/courseBook', query: {name:record.name,class: record.id}})">课程教材</a-button>
                        </a-badge>
                        <a-button type="primary" ghost style="margin-right:10px" @click="$router.push({path:'/analysis/contentList', query: {name:record.name,class: record.id}})">班级与资料</a-button>
                    </a-space>
                </template>
            </a-table>
        </div>
    </div>
</template>
<script>
    const columns = [
        {
            title: '科目名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'className' },
            align:'center'
        },{
            title: '科目代码',
            dataIndex: 'code',
            align:'center'
        }, {
            title: '首页展示',
            dataIndex: 'is_home',
            align:'center',
            scopedSlots: { customRender: 'homeShow' },
        }, {
            title: '展示状态',
            dataIndex: 'show',
            align:'center',
            scopedSlots: { customRender: 'showList' },
        }, {
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    import * as http from '@/libs/analysis'
    import addOpencourse from '@/components/analysis/addOpencourse'
    import Loading from '@/components/loading'
    export default {
        name: 'openCourse',
        components: { Loading,addOpencourse },
        data(){
            return{
                result: [],
                columns,
                visible: false,
                loading: true,
                currentItem: [],
                filter:{
                    cate_id: 0,
                    keywords:''
                },
                pagination:{
                    page: 1,
                    total: 0,
                    size: '15',
                    pageSize: 15
                },
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getData()
            })
        },
        methods:{
            changePage({current}){
                this.pagination.page = current
                this.getData()
            },
            setShow(index , id){
                this.loading = true
                http.show_course_subject({id:id}).then(res=>{
                    this.loading = false;
                    this.result[index]['show'] = !this.result[index]['show'];
                }).catch(error=>{
                    this.loading = false
                    console.log(error)
                })
            },
            setHomeShow(index , id){
                this.loading = true
                http.show_course_subject({id:id, type:'is_home'}).then(res=>{
                    this.loading = false;
                    this.result[index]['is_home'] = !this.result[index]['is_home'];
                }).catch(error=>{
                    this.loading = false
                    console.log(error)
                })
            },
            getData(){
                this.result = [];
                this.loading = true;
                let request = {...this.filter,...this.pagination}
                if(this.filter.cate_id == 0){
                    request.cate_id = null
                }
                http.get_course_subject(request).then(res=>{
                    this.loading = false
                    this.result = res.data
                    this.pagination.total = res.total
                }).catch(error=>{
                    this.loading = false
                    console.log(error)
                })
            },
            lookPapers(record){
              if(!record.cate_id) return this.$message.error('先关联分类');
              this.$router.push({path:'/analysis/sourcePapers', query: {name:record.name, bind_catid: record.cate_id}})
            },
            questionBank(record){
              if(!record.cate_id) return this.$message.error('先关联分类');
              this.$router.push({path:'/analysis/questionBank', query: {name:record.name, bind_catid: record.cate_id}})
            },
            vipQuestionBank(record){
              if(!record.cate_id) return this.$message.error('先关联分类');
              this.$router.push({path:'/analysis/vipQuestionBank', query: {name:record.name, bind_catid: record.cate_id}})
            },
            onSelectChange(){

            },
            addItem(){
                this.currentItem = [];
                console.log(this.currentItem)
                this.visible = true;
            },
            deleteItem(id){
                let _this = this
                this.$confirm({
                    title: '是否确定删除该科目?',
                    centered: true,
                    onOk() {
                        http.del_course_subject({id}).then(res=>{
                            _this.getData()
                        }).catch(error=>{
                            console.log(error)
                        })
                    },
                });
            },
            hideModal(){

            }
        }
    }
</script>
<style lang="less" scoped>

</style>
